
const citcMockStationList = [
  {
    "name":"Bedford",
    "nlc":"1512",
    "crs":"BDM",
    "latitude":52.1362,
    "longitude":-0.47944,
    "address":"Bedford station\nAshburnham Road\nBedford\nBedfordshire\nMK40 1DS",
    "facilities":[
      "SeatedArea",
      "StationBuffet",
      "Toilets",
      "BabyChange",
      "WiFi",
      "PostBox",
      "AtmMachine",
      "Shops"
    ],
    "categories":[
      "NationalRail"
    ],
    "gazetteer":{
      "withinGoldcardArea":true,
      "smartcardsAvailable":true,
      "isZonalOrGroup":false,
      "isOpen":true,
      "isClosed":false,
      "isOpeningSoon":false
    },
    "plusbusNlc":"J223"
  },
  {
    "name":"Leagrave",
    "nlc":"1534",
    "crs":"LEA",
    "latitude":51.90517,
    "longitude":-0.45851,
    "address":"Leagrave station\nCompton Avenue\nLeagrave\nBedfordshire\nLU4 9BA",
    "facilities":[
      "SeatedArea",
      "StationBuffet",
      "Toilets",
      "WiFi",
      "PostBox"
    ],
    "categories":[
      "NationalRail"
    ],
    "gazetteer":{
      "withinGoldcardArea":true,
      "smartcardsAvailable":true,
      "isZonalOrGroup":false,
      "isOpen":true,
      "isClosed":false,
      "isOpeningSoon":false
    },
    "plusbusNlc":"H135"
  },
  {
    "name":"Harpenden",
    "nlc":"1543",
    "crs":"HPD",
    "latitude":51.81488,
    "longitude":-0.35198,
    "address":"Harpenden station\nStation Road\nHarpenden\nHertfordshire\nAL5 4SP",
    "facilities":[
      "SeatedArea",
      "StationBuffet",
      "Toilets",
      "WiFi",
      "Shops"
    ],
    "categories":[
      "NationalRail"
    ],
    "gazetteer":{
      "withinGoldcardArea":true,
      "smartcardsAvailable":true,
      "isZonalOrGroup":false,
      "isOpen":true,
      "isClosed":false,
      "isOpeningSoon":false
    },
    "plusbusNlc":"H896"
  },
  {
    "name":"Luton",
    "nlc":"1536",
    "crs":"LUT",
    "latitude":51.88231,
    "longitude":-0.41404,
    "address":"Luton station\nStation Road\nLuton\nBedfordshire\nLU1 2LT",
    "facilities":[
      "SeatedArea",
      "StationBuffet",
      "Toilets",
      "WiFi",
      "PostBox",
      "AtmMachine"
    ],
    "categories":[
      "NationalRail"
    ],
    "gazetteer":{
      "withinGoldcardArea":true,
      "smartcardsAvailable":true,
      "isZonalOrGroup":false,
      "isOpen":true,
      "isClosed":false,
      "isOpeningSoon":false
    },
    "plusbusNlc":"H134"
  },
  {
    "name":"Luton Airport Parkway",
    "nlc":"3645",
    "crs":"LTN",
    "latitude":51.87286,
    "longitude":-0.3962,
    "address":"Luton Airport Parkway station\nParkway Road\nLuton\nBedfordshire\nLU1 3JW",
    "facilities":[
      "SeatedArea",
      "StationBuffet",
      "Toilets",
      "BabyChange",
      "WiFi",
      "PostBox",
      "AtmMachine",
      "Shops"
    ],
    "categories":[
      "NationalRail"
    ],
    "gazetteer":{
      "withinGoldcardArea":true,
      "smartcardsAvailable":true,
      "isZonalOrGroup":false,
      "isOpen":true,
      "isClosed":false,
      "isOpeningSoon":false
    }
  },
  {
    "name":"St Albans City",
    "nlc":"1548",
    "crs":"SAC",
    "latitude":51.75048,
    "longitude":-0.32754,
    "address":"St Albans station\nStation Way\nSt. Albans\nHertfordshire\nAL1 5HE",
    "facilities":[
      "SeatedArea",
      "StationBuffet",
      "Toilets",
      "BabyChange",
      "WiFi",
      "PostBox",
      "AtmMachine",
      "Shops"
    ],
    "categories":[
      "NationalRail"
    ],
    "gazetteer":{
      "withinGoldcardArea":true,
      "smartcardsAvailable":true,
      "isZonalOrGroup":false,
      "isOpen":true,
      "isClosed":false,
      "isOpeningSoon":false
    },
    "plusbusNlc":"H893"
  },
  {
    "name":"Huntingdon",
    "nlc":"6108",
    "crs":"HUN",
    "latitude":52.32866,
    "longitude":-0.19206,
    "address":"Huntingdon station\nBrampton Road\nHuntingdon\nCambridgeshire\nPE29 3BP",
    "facilities":[
      "SeatedArea",
      "WaitingRoom",
      "StationBuffet",
      "Toilets",
      "BabyChange",
      "WiFi",
      "PostBox",
      "AtmMachine"
    ],
    "categories":[
      "NationalRail"
    ],
    "gazetteer":{
      "withinGoldcardArea":true,
      "smartcardsAvailable":true,
      "isZonalOrGroup":false,
      "isOpen":true,
      "isClosed":false,
      "isOpeningSoon":false
    },
    "plusbusNlc":"J391"
  },
  {
    "name":"St Neots",
    "nlc":"6110",
    "crs":"SNO",
    "latitude":52.23158,
    "longitude":-0.24741,
    "address":"St Neots station\nHawkesden Road\nSt Neots\nCambridgeshire\nPE19 1QF",
    "facilities":[
      "SeatedArea",
      "StationBuffet",
      "Toilets",
      "BabyChange",
      "WiFi",
      "PostBox"
    ],
    "categories":[
      "NationalRail"
    ],
    "gazetteer":{
      "withinGoldcardArea":true,
      "smartcardsAvailable":true,
      "isZonalOrGroup":false,
      "isOpen":true,
      "isClosed":false,
      "isOpeningSoon":false
    },
    "plusbusNlc":"J414"
  },
  {
    "name":"Letchworth Garden City",
    "nlc":"6089",
    "crs":"LET",
    "latitude":51.97997,
    "longitude":-0.22926,
    "address":"Letchworth Garden City station\nStation Road\nLetchworth Garden City\nHertfordshire\nSG6 3AN",
    "facilities":[
      "SeatedArea",
      "WaitingRoom",
      "StationBuffet",
      "Toilets",
      "WiFi",
      "Shops"
    ],
    "categories":[
      "NationalRail"
    ],
    "gazetteer":{
      "withinGoldcardArea":true,
      "smartcardsAvailable":true,
      "isZonalOrGroup":false,
      "isOpen":true,
      "isClosed":false,
      "isOpeningSoon":false
    },
    "plusbusNlc":"H876"
  },
  {
    "name":"Royston (Herts)",
    "nlc":"6090",
    "crs":"RYS",
    "latitude":52.05309,
    "longitude":-0.02691,
    "address":"Royston station\nKneesworth Street\nRoyston\nHertfordshire\nSG8 5AH",
    "facilities":[
      "SeatedArea",
      "WaitingRoom",
      "StationBuffet",
      "Toilets",
      "WiFi",
      "Shops"
    ],
    "categories":[
      "NationalRail"
    ],
    "gazetteer":{
      "withinGoldcardArea":true,
      "smartcardsAvailable":true,
      "isZonalOrGroup":false,
      "isOpen":true,
      "isClosed":false,
      "isOpeningSoon":false
    },
    "plusbusNlc":"K714"
  },
  {
    "name":"Hitchin",
    "nlc":"6086",
    "crs":"HIT",
    "latitude":51.95329,
    "longitude":-0.26348,
    "address":"Hitchin station\nWalsworth Road\nHitchin\nHertfordshire\nSG4 9UL",
    "facilities":[
      "SeatedArea",
      "WaitingRoom",
      "StationBuffet",
      "Toilets",
      "BabyChange",
      "WiFi",
      "AtmMachine",
      "Shops"
    ],
    "categories":[
      "NationalRail"
    ],
    "gazetteer":{
      "withinGoldcardArea":true,
      "smartcardsAvailable":true,
      "isZonalOrGroup":false,
      "isOpen":true,
      "isClosed":false,
      "isOpeningSoon":false
    },
    "plusbusNlc":"H874"
  },
  {
    "name":"Stevenage",
    "nlc":"6092",
    "crs":"SVG",
    "latitude":51.90169,
    "longitude":-0.20711,
    "address":"Stevenage station\nLytton Way\nStevenage\nHertfordshire\nSG1 1XT",
    "facilities":[
      "SeatedArea",
      "WaitingRoom",
      "StationBuffet",
      "Toilets",
      "BabyChange",
      "WiFi",
      "AtmMachine",
      "Shops"
    ],
    "categories":[
      "NationalRail"
    ],
    "gazetteer":{
      "withinGoldcardArea":true,
      "smartcardsAvailable":true,
      "isZonalOrGroup":false,
      "isOpen":true,
      "isClosed":false,
      "isOpeningSoon":false
    },
    "plusbusNlc":"H879"
  },
  {
    "name":"Hertford North",
    "nlc":"6085",
    "crs":"HFN",
    "latitude":51.79886,
    "longitude":-0.09178,
    "address":"Hertford North station\nNorth Road\nHertford\nHertfordshire\nSG14 1NB",
    "facilities":[
      "SeatedArea",
      "WaitingRoom",
      "StationBuffet",
      "Toilets",
      "WiFi",
      "Shops"
    ],
    "categories":[
      "NationalRail"
    ],
    "gazetteer":{
      "withinGoldcardArea":true,
      "smartcardsAvailable":true,
      "isZonalOrGroup":false,
      "isOpen":true,
      "isClosed":false,
      "isOpeningSoon":false
    }
  },
  {
    "name":"Welwyn Garden City",
    "nlc":"6183",
    "crs":"WGC",
    "latitude":51.80105,
    "longitude":-0.20407,
    "address":"Welwyn Garden City station\ninside The Howard Centre shopping m\nWelwyn Garden City\nHertfordshire\nAL8 6HA",
    "facilities":[
      "SeatedArea",
      "WaitingRoom",
      "StationBuffet",
      "Toilets",
      "WiFi",
      "AtmMachine"
    ],
    "categories":[
      "NationalRail"
    ],
    "gazetteer":{
      "withinGoldcardArea":true,
      "smartcardsAvailable":true,
      "isZonalOrGroup":false,
      "isOpen":true,
      "isClosed":false,
      "isOpeningSoon":false
    },
    "plusbusNlc":"H870"
  },
  {
    "name":"Hatfield (Herts)",
    "nlc":"6070",
    "crs":"HAT",
    "latitude":51.76388,
    "longitude":-0.21559,
    "address":"Hatfield station\n79 Great North Road\nHatfield\nHertfordshire\nAL9 5AB",
    "facilities":[
      "SeatedArea",
      "WaitingRoom",
      "StationBuffet",
      "Toilets",
      "BabyChange",
      "WiFi",
      "PostBox",
      "AtmMachine",
      "Shops"
    ],
    "categories":[
      "NationalRail"
    ],
    "gazetteer":{
      "withinGoldcardArea":true,
      "smartcardsAvailable":true,
      "isZonalOrGroup":false,
      "isOpen":true,
      "isClosed":false,
      "isOpeningSoon":false
    },
    "plusbusNlc":"H872"
  },
  {
    "name":"Potters Bar",
    "nlc":"6022",
    "crs":"PBR",
    "latitude":51.69729,
    "longitude":-0.19236,
    "address":"Potters Bar station\nDarkes Lane\nPotters Bar\nHertfordshire\nEN6 1AJ",
    "facilities":[
      "SeatedArea",
      "WaitingRoom",
      "StationBuffet",
      "Toilets",
      "BabyChange",
      "WiFi",
      "AtmMachine",
      "Shops"
    ],
    "categories":[
      "NationalRail"
    ],
    "gazetteer":{
      "withinGoldcardArea":true,
      "smartcardsAvailable":true,
      "isZonalOrGroup":false,
      "isOpen":true,
      "isClosed":false,
      "isOpeningSoon":false
    },
    "plusbusNlc":"H877"
  },
  {
    "name":"London Thameslink",
    "nlc":"4452",
    "crs":"",
    "latitude":51.517218,
    "longitude":-0.103775,
    "categories":[
      "NationalRail"
    ],
    "gazetteer":{
      "londonZones":[
        "1"
      ],
      "withinGoldcardArea":true,
      "smartcardsAvailable":true,
      "isZonalOrGroup":false,
      "isOpen":true,
      "isClosed":false,
      "isOpeningSoon":false
    }
  },
  {
    "name":"London Terminals",
    "nlc":"1072",
    "crs":"",
    "latitude":51.510107,
    "longitude":-0.134674,
    "categories":[
      "NationalRail",
      "LondonUnderground"
    ],
    "gazetteer":{
      "londonZones":[
        "1"
      ],
      "withinGoldcardArea":true,
      "smartcardsAvailable":true,
      "isZonalOrGroup":false,
      "isOpen":true,
      "isClosed":false,
      "isOpeningSoon":false
    }
  }
];

export default citcMockStationList;
